var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"form_steps"},[_vm._v("Paso "+_vm._s(_vm.stepNum)+"/"+_vm._s(_vm.totalSteps))])
}
var staticRenderFns = []

export { render, staticRenderFns }